import type { FormDrawerProps } from '../../FormDrawer';
import { QuickBooksConfigurationForm } from './components/QuickBooksConfigurationForm';
import { QuickBooksConfigurationFormSchema } from './QuickBooksConfigurationFormSchema';
import { QuickBooksConfigurationFooter } from './components/QuickBooksConfigurationFooter';

export const ConfigureQuickBooksComponents: FormDrawerProps = {
  zodSchema: QuickBooksConfigurationFormSchema,
  ContentComponent: QuickBooksConfigurationForm,
  Footer: QuickBooksConfigurationFooter,
};
